module.exports = __webpack_public_path__ + "img/restaurant-4.fa2e71ae.jpg";